import React from 'react'
import { LaunchAlertText } from './index.style.js'
import { LaunchAlertWrapper } from './components.js'

function LoginLaunchAlert() {
  return (
    <LaunchAlertWrapper>
      <LaunchAlertText>
        This page will soon get a new layout. This will be the 1st step of
        transition to the new Editor application.{' '}
        <a
          href="https://mailchi.mp/opinary.com/dashboard-launch-signups"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more at the info page
        </a>
        .
      </LaunchAlertText>
    </LaunchAlertWrapper>
  )
}

export default LoginLaunchAlert



// WEBPACK FOOTER //
// ./src/components/LaunchAlert/LoginLaunchAlert.js